// tslint:disable:no-any
// tslint:disable:max-line-length
import AuthWeb from 'auth0-js';

// var AuthIcon = require('../assets/img/wetnotes-150x150.jpg');

export class AuthLock {
    public static instance: AuthLock;
    private authWeb: AuthWeb.WebAuth;

    public static getInstance() {
        if (!AuthLock.instance) {
            AuthLock.instance = new AuthLock();
        }

        return AuthLock.instance;
    }

    public showLock(options?: Auth0LockShowOptions) {
        this.authWeb.authorize();
    }

    public showLogIn() {
        // Auth.removeLocalStorage();
        this.showLock();
    }

    public showSignUp() {
        // Auth.removeLocalStorage();
        this.authWeb.authorize({
            initialScreen: 'signUp'
        } as Auth0LockAuthOptions);
    }

    private initialize() {
        this.authWeb = new AuthWeb.WebAuth({
            clientID: (window as any).__REACT_SETTINGS.clientId,
            domain: (window as any).__REACT_SETTINGS.domain,
            scope: 'all:access email profile openid',
            responseType: 'id_token token',
            redirectUri: (window as any).__REACT_SETTINGS.callbackUrl,
            audience: (window as any).__REACT_SETTINGS.apiUrl
        });
    }

    private constructor() {
        this.initialize();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/AuthLock.ts